import { useQuery } from '@tanstack/react-query';

import ReservationService from '~/services/ReservationService';

import { DateFlagBlock, roomRateAvailabilityQueryKeys } from './roomRateAvailabilityQueryKeys';

export function useGetRoomRateSurchargeDates(
  propertyId: string | undefined,
  roomTypeId: string | undefined,
  roomRateId: string | undefined,
) {
  return useQuery<Array<DateFlagBlock>>({
    queryKey: roomRateAvailabilityQueryKeys.surcharge(propertyId ?? '', roomTypeId ?? '', roomRateId ?? ''),
    queryFn: async () =>
      (await ReservationService.getSurchargeDates(propertyId, roomTypeId, roomRateId)).result?.dates ?? [],
    enabled: !!propertyId && !!roomTypeId && !!roomRateId,
  });
}
